import { Component, ElementRef, Input, OnInit, ViewEncapsulation } from "@angular/core";
import * as L from "leaflet";
import { MapRepository } from "./services/map.repository";
import { WebComponentInitializerService } from "../shared/web-component-initializer.service";
import { MapDefinition } from "./model/map.model";

@Component({
    selector: "dffedb-map",
    template: '<div id="{{ mapId }}"></div>',
    styleUrls: ["./dffedb-map.component.css"],
    encapsulation: ViewEncapsulation.ShadowDom
})
export class DffedbMapComponent implements OnInit {
    @Input() public nodeId: number;
    @Input() public mapData: MapDefinition | undefined;
    public mapId: string;

    private map!: L.Map;
    private baseMapURl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

    private nonTiledLayer = false;
    constructor(
        private readonly webComponentInitializer: WebComponentInitializerService,
        private readonly mapRepository: MapRepository,
        private el: ElementRef
    ) {}

    public ngOnInit(): void {
        if (this.nodeId == null) {
            console.warn("dffedb-map: nodeId mangler");
            return;
        }
        this.webComponentInitializer.init(this.nodeId);
        this.mapId = "map" + this.nodeId.toString();
        this.mapRepository.selectKonfiguration(+this.nodeId).subscribe({
            next: (data) => {
                this.mapData = data;
                if (this.mapData.startKoordinaterX) {
                    this.initMap(this.mapData);
                } else {
                    console.log("Map data is not available or invalid.");
                }
            },
            error: (err) => {
                console.log("Error:", err);
            }
        });
    }

    private initMap(mapData: MapDefinition) {
        const shadowRoot = this.el.nativeElement?.shadowRoot;
        if (!shadowRoot) {
            console.warn("dffedb-map: shadowRoot ikke tilgængelig");
            return;
        }
        const mapElement = shadowRoot.querySelector("#" + this.mapId);
        if (!mapElement) {
            console.warn("dffedb-map: map-container ikke fundet for id", this.mapId);
            return;
        }
        mapElement.style.height = mapData.hoejde ? mapData.hoejde + "px" : "300px";
        let tileLayerUrl = mapData.tileLayer ?? "";
        if (tileLayerUrl && (tileLayerUrl.endsWith("dk/") || tileLayerUrl.endsWith("dk"))) {
            if (!tileLayerUrl.endsWith("/")) {
                tileLayerUrl += "/";
            }
            tileLayerUrl += "geoserver/ows?SERVICE=WMS&";
        }
        this.map = L.map(mapElement, {
            crs: L.CRS.EPSG3857,
            center: [mapData.startKoordinaterX, mapData.startKoordinaterY],
            zoom: mapData.mapZoom ? mapData.mapZoom : 12
        });
        if (mapData.scrollWheelZoom) {
            this.map.scrollWheelZoom.enable();
        } else {
            this.map.scrollWheelZoom.disable();
        }
        L.tileLayer(this.baseMapURl, {
            maxZoom: 25,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        if (!this.nonTiledLayer && tileLayerUrl) {
            L.tileLayer
                .wms(tileLayerUrl, {
                    layers: mapData.layers ? mapData.layers : "ugraph-network:DF_Pipe_LER",
                    format: "image/png",
                    transparent: true,
                    attribution: "Softværket"
                })
                .addTo(this.map);
        }
    }
}
